<template>
  <Layout>
    <Navbar/>
    <router-view style="margin-top:84px;"></router-view>
  </Layout>
</template>

<script>
import Navbar from '@/components/base/Navbar.vue'
export default {
  components: {
    Navbar
  },
}
</script>

<style>

</style>
